// Centralized API configuration
// This handles backend URL across all environments

function getBackendURL() {
  // Priority 1: Environment variable (injected at build time)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }

  // Priority 2: Use current origin (works for most deployments)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }

  // Fallback for SSR or build time
  return 'http://localhost:3000';
}

export const BACKEND_URL = getBackendURL();
export const API_URL = `${BACKEND_URL}/api`;

// Export function for direct use
export function getBackendUrl() {
  return API_URL;
}

// Helper to get image URLs
// Memoize to prevent unnecessary recalculations
const imageUrlCache = new Map();

export function getImageUrl(path) {
  if (!path) return '';
  
  // Check cache first
  if (imageUrlCache.has(path)) {
    return imageUrlCache.get(path);
  }
  
  // Strip out any /api/uploads/ that might be in the path
  let cleanPath = path.replace('/api/uploads/', '/');
  
  let result;
  // All image URLs in database are now full R2 URLs
  // If it's already a full URL (http:// or https://), return as-is
  if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://')) {
    result = cleanPath;
  } else {
    // Legacy support: if path doesn't start with http, assume it's a filename
    // Construct URL using R2 public URL from environment or default Fallen Dragon R2
    const r2PublicUrl = process.env.REACT_APP_R2_PUBLIC_URL || 'https://images.fallendragonevents.co.uk';
    result = `${r2PublicUrl}/${cleanPath.replace(/^\//, '')}`;
  }
  
  // Cache the result
  imageUrlCache.set(path, result);
  return result;
}

export default {
  BACKEND_URL,
  API_URL,
  getImageUrl
};
